import { AppEnv } from 'core/enums';
import { APP_ENV, DOMAIN_URL } from 'global';

import { mapArrayToNameValueObject } from './array';

const getUrlSource = (url: string) => {
  if (!url) {
    return '';
  }

  if (APP_ENV !== AppEnv.DEVELOPMENT) {
    return url;
  }

  return [DOMAIN_URL, url].join('');
};

export const getLogoPaths = (paths: []) => {
  const logoPaths = mapArrayToNameValueObject(paths, 'logo_');

  return Object.keys(logoPaths).reduce(
    (map, key) => ({ ...map, [key]: getUrlSource(logoPaths[key]) }),
    {}
  );
};
